import { Component } from '@angular/core';

@Component({
    selector: 'self-ins-enrollment-confirmation',
    templateUrl: './enrollment-confirmation-page.component.html',
    styleUrls: ['./enrollment-confirmation-page.component.scss']
})

export class EnrollmentConfirmationPageComponent {}